import { render, staticRenderFns } from "./CustomerBillingAddressDeleteDrawer.vue?vue&type=template&id=fa6a2a90"
import script from "./CustomerBillingAddressDeleteDrawer.vue?vue&type=script&lang=js"
export * from "./CustomerBillingAddressDeleteDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports